import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-button" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "col q-pa-sm center-btn"
}
const _hoisted_4 = { class: "col q-pa-sm center-btn" }
const _hoisted_5 = {
  key: 1,
  class: "col q-pa-sm center-btn"
}
const _hoisted_6 = { class: "col q-pa-sm center-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.enableAddBtn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_q_btn, {
              round: "",
              color: "primary",
              icon: "add",
              onClick: _ctx.add
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.tooltipAdd), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_btn, {
          round: "",
          color: "accent",
          icon: "search",
          onClick: _ctx.search
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(" Buscar registros ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      (_ctx.enableOrderBtn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_q_btn, {
              round: "",
              color: "primary",
              icon: "list_alt"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_list, {
                      dense: "",
                      style: {"min-width":"100px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
                          return (_openBlock(), _createBlock(_component_q_item, {
                            key: index,
                            clickable: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(field.label), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_item_section, { side: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, { name: "keyboard_arrow_right" })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_menu, {
                                anchor: "top end",
                                self: "top start"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_list, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item, {
                                        dense: "",
                                        clickable: "",
                                        onClick: ($event: any) => (_ctx.onSortBy(field.name, false))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Ascendente ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_q_item, {
                                        dense: "",
                                        clickable: "",
                                        onClick: ($event: any) => (_ctx.onSortBy(field.name, true))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Descendente ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ordenar registros ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_btn, {
          round: "",
          color: "negative",
          icon: "auto_delete",
          onClick: _ctx.reset
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(" Limpiar filtros de búsqueda ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}